/* eslint-disable */
  /*! jQuery UI - v1.11.4 - 2016-02-26
  * http://jqueryui.com
  * Includes: core.js, widget.js, button.js, spinner.js
  * Copyright jQuery Foundation and other contributors; Licensed MIT */
  
  (function( factory ) {
      if ( typeof define === "function" && define.amd ) {
  
          // AMD. Register as an anonymous module.
          define([ "jquery" ], factory );
      } else {
  
          // Browser globals
          factory( jQuery );
      }
  }(function( $ ) {
  /*!
   * jQuery UI Core 1.11.4
   * http://jqueryui.com
   *
   * Copyright jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */
  
  
  // $.ui might exist from components with no dependencies, e.g., $.ui.position
  $.ui = $.ui || {};
  
  $.extend( $.ui, {
      version: "1.11.4",
  
      keyCode: {
          BACKSPACE: 8,
          COMMA: 188,
          DELETE: 46,
          DOWN: 40,
          END: 35,
          ENTER: 13,
          ESCAPE: 27,
          HOME: 36,
          LEFT: 37,
          PAGE_DOWN: 34,
          PAGE_UP: 33,
          PERIOD: 190,
          RIGHT: 39,
          SPACE: 32,
          TAB: 9,
          UP: 38
      }
  });
  
  // plugins
  $.fn.extend({
      scrollParent: function( includeHidden ) {
          var position = this.css( "position" ),
              excludeStaticParent = position === "absolute",
              overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
              scrollParent = this.parents().filter( function() {
                  var parent = $( this );
                  if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
                      return false;
                  }
                  return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) + parent.css( "overflow-x" ) );
              }).eq( 0 );
  
          return position === "fixed" || !scrollParent.length ? $( this[ 0 ].ownerDocument || document ) : scrollParent;
      },
  
      uniqueId: (function() {
          var uuid = 0;
  
          return function() {
              return this.each(function() {
                  if ( !this.id ) {
                      this.id = "ui-id-" + ( ++uuid );
                  }
              });
          };
      })(),
  
      removeUniqueId: function() {
          return this.each(function() {
              if ( /^ui-id-\d+$/.test( this.id ) ) {
                  $( this ).removeAttr( "id" );
              }
          });
      }
  });
  
  // selectors
  function focusable( element, isTabIndexNotNaN ) {
      var map, mapName, img,
          nodeName = element.nodeName.toLowerCase();
      if ( "area" === nodeName ) {
          map = element.parentNode;
          mapName = map.name;
          if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
              return false;
          }
          img = $( "img[usemap='#" + mapName + "']" )[ 0 ];
          return !!img && visible( img );
      }
      return ( /^(input|select|textarea|button|object)$/.test( nodeName ) ?
          !element.disabled :
          "a" === nodeName ?
              element.href || isTabIndexNotNaN :
              isTabIndexNotNaN) &&
          // the element and all of its ancestors must be visible
          visible( element );
  }
  
  function visible( element ) {
      return $.expr.filters.visible( element ) &&
          !$( element ).parents().addBack().filter(function() {
              return $.css( this, "visibility" ) === "hidden";
          }).length;
  }
  
  $.extend( $.expr[ ":" ], {
      data: $.expr.createPseudo ?
          $.expr.createPseudo(function( dataName ) {
              return function( elem ) {
                  return !!$.data( elem, dataName );
              };
          }) :
          // support: jQuery <1.8
          function( elem, i, match ) {
              return !!$.data( elem, match[ 3 ] );
          },
  
      focusable: function( element ) {
          return focusable( element, !isNaN( $.attr( element, "tabindex" ) ) );
      },
  
      tabbable: function( element ) {
          var tabIndex = $.attr( element, "tabindex" ),
              isTabIndexNaN = isNaN( tabIndex );
          return ( isTabIndexNaN || tabIndex >= 0 ) && focusable( element, !isTabIndexNaN );
      }
  });
  
  // support: jQuery <1.8
  if ( !$( "<a>" ).outerWidth( 1 ).jquery ) {
      $.each( [ "Width", "Height" ], function( i, name ) {
          var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
              type = name.toLowerCase(),
              orig = {
                  innerWidth: $.fn.innerWidth,
                  innerHeight: $.fn.innerHeight,
                  outerWidth: $.fn.outerWidth,
                  outerHeight: $.fn.outerHeight
              };
  
          function reduce( elem, size, border, margin ) {
              $.each( side, function() {
                  size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
                  if ( border ) {
                      size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
                  }
                  if ( margin ) {
                      size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
                  }
              });
              return size;
          }
  
          $.fn[ "inner" + name ] = function( size ) {
              if ( size === undefined ) {
                  return orig[ "inner" + name ].call( this );
              }
  
              return this.each(function() {
                  $( this ).css( type, reduce( this, size ) + "px" );
              });
          };
  
          $.fn[ "outer" + name] = function( size, margin ) {
              if ( typeof size !== "number" ) {
                  return orig[ "outer" + name ].call( this, size );
              }
  
              return this.each(function() {
                  $( this).css( type, reduce( this, size, true, margin ) + "px" );
              });
          };
      });
  }
  
  // support: jQuery <1.8
  if ( !$.fn.addBack ) {
      $.fn.addBack = function( selector ) {
          return this.add( selector == null ?
              this.prevObject : this.prevObject.filter( selector )
          );
      };
  }
  
  // support: jQuery 1.6.1, 1.6.2 (http://bugs.jquery.com/ticket/9413)
  if ( $( "<a>" ).data( "a-b", "a" ).removeData( "a-b" ).data( "a-b" ) ) {
      $.fn.removeData = (function( removeData ) {
          return function( key ) {
              if ( arguments.length ) {
                  return removeData.call( this, $.camelCase( key ) );
              } else {
                  return removeData.call( this );
              }
          };
      })( $.fn.removeData );
  }
  
  // deprecated
  $.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );
  
  $.fn.extend({
      focus: (function( orig ) {
          return function( delay, fn ) {
              return typeof delay === "number" ?
                  this.each(function() {
                      var elem = this;
                      setTimeout(function() {
                          $( elem ).focus();
                          if ( fn ) {
                              fn.call( elem );
                          }
                      }, delay );
                  }) :
                  orig.apply( this, arguments );
          };
      })( $.fn.focus ),
  
      disableSelection: (function() {
          var eventType = "onselectstart" in document.createElement( "div" ) ?
              "selectstart" :
              "mousedown";
  
          return function() {
              return this.bind( eventType + ".ui-disableSelection", function( event ) {
                  event.preventDefault();
              });
          };
      })(),
  
      enableSelection: function() {
          return this.unbind( ".ui-disableSelection" );
      },
  
      zIndex: function( zIndex ) {
          if ( zIndex !== undefined ) {
              return this.css( "zIndex", zIndex );
          }
  
          if ( this.length ) {
              var elem = $( this[ 0 ] ), position, value;
              while ( elem.length && elem[ 0 ] !== document ) {
                  // Ignore z-index if position is set to a value where z-index is ignored by the browser
                  // This makes behavior of this function consistent across browsers
                  // WebKit always returns auto if the element is positioned
                  position = elem.css( "position" );
                  if ( position === "absolute" || position === "relative" || position === "fixed" ) {
                      // IE returns 0 when zIndex is not specified
                      // other browsers return a string
                      // we ignore the case of nested elements with an explicit value of 0
                      // <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
                      value = parseInt( elem.css( "zIndex" ), 10 );
                      if ( !isNaN( value ) && value !== 0 ) {
                          return value;
                      }
                  }
                  elem = elem.parent();
              }
          }
  
          return 0;
      }
  });
  
  // $.ui.plugin is deprecated. Use $.widget() extensions instead.
  $.ui.plugin = {
      add: function( module, option, set ) {
          var i,
              proto = $.ui[ module ].prototype;
          for ( i in set ) {
              proto.plugins[ i ] = proto.plugins[ i ] || [];
              proto.plugins[ i ].push( [ option, set[ i ] ] );
          }
      },
      call: function( instance, name, args, allowDisconnected ) {
          var i,
              set = instance.plugins[ name ];
  
          if ( !set ) {
              return;
          }
  
          if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode || instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
              return;
          }
  
          for ( i = 0; i < set.length; i++ ) {
              if ( instance.options[ set[ i ][ 0 ] ] ) {
                  set[ i ][ 1 ].apply( instance.element, args );
              }
          }
      }
  };
  
  
  /*!
   * jQuery UI Widget 1.11.4
   * http://jqueryui.com
   *
   * Copyright jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/jQuery.widget/
   */
  
  
  var widget_uuid = 0,
      widget_slice = Array.prototype.slice;
  
  $.cleanData = (function( orig ) {
      return function( elems ) {
          var events, elem, i;
          for ( i = 0; (elem = elems[i]) != null; i++ ) {
              try {
  
                  // Only trigger remove when necessary to save time
                  events = $._data( elem, "events" );
                  if ( events && events.remove ) {
                      $( elem ).triggerHandler( "remove" );
                  }
  
              // http://bugs.jquery.com/ticket/8235
              } catch ( e ) {}
          }
          orig( elems );
      };
  })( $.cleanData );
  
  $.widget = function( name, base, prototype ) {
      var fullName, existingConstructor, constructor, basePrototype,
          // proxiedPrototype allows the provided prototype to remain unmodified
          // so that it can be used as a mixin for multiple widgets (#8876)
          proxiedPrototype = {},
          namespace = name.split( "." )[ 0 ];
  
      name = name.split( "." )[ 1 ];
      fullName = namespace + "-" + name;
  
      if ( !prototype ) {
          prototype = base;
          base = $.Widget;
      }
  
      // create selector for plugin
      $.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
          return !!$.data( elem, fullName );
      };
  
      $[ namespace ] = $[ namespace ] || {};
      existingConstructor = $[ namespace ][ name ];
      constructor = $[ namespace ][ name ] = function( options, element ) {
          // allow instantiation without "new" keyword
          if ( !this._createWidget ) {
              return new constructor( options, element );
          }
  
          // allow instantiation without initializing for simple inheritance
          // must use "new" keyword (the code above always passes args)
          if ( arguments.length ) {
              this._createWidget( options, element );
          }
      };
      // extend with the existing constructor to carry over any static properties
      $.extend( constructor, existingConstructor, {
          version: prototype.version,
          // copy the object used to create the prototype in case we need to
          // redefine the widget later
          _proto: $.extend( {}, prototype ),
          // track widgets that inherit from this widget in case this widget is
          // redefined after a widget inherits from it
          _childConstructors: []
      });
  
      basePrototype = new base();
      // we need to make the options hash a property directly on the new instance
      // otherwise we'll modify the options hash on the prototype that we're
      // inheriting from
      basePrototype.options = $.widget.extend( {}, basePrototype.options );
      $.each( prototype, function( prop, value ) {
          if ( !$.isFunction( value ) ) {
              proxiedPrototype[ prop ] = value;
              return;
          }
          proxiedPrototype[ prop ] = (function() {
              var _super = function() {
                      return base.prototype[ prop ].apply( this, arguments );
                  },
                  _superApply = function( args ) {
                      return base.prototype[ prop ].apply( this, args );
                  };
              return function() {
                  var __super = this._super,
                      __superApply = this._superApply,
                      returnValue;
  
                  this._super = _super;
                  this._superApply = _superApply;
  
                  returnValue = value.apply( this, arguments );
  
                  this._super = __super;
                  this._superApply = __superApply;
  
                  return returnValue;
              };
          })();
      });
      constructor.prototype = $.widget.extend( basePrototype, {
          // TODO: remove support for widgetEventPrefix
          // always use the name + a colon as the prefix, e.g., draggable:start
          // don't prefix for widgets that aren't DOM-based
          widgetEventPrefix: existingConstructor ? (basePrototype.widgetEventPrefix || name) : name
      }, proxiedPrototype, {
          constructor: constructor,
          namespace: namespace,
          widgetName: name,
          widgetFullName: fullName
      });
  
      // If this widget is being redefined then we need to find all widgets that
      // are inheriting from it and redefine all of them so that they inherit from
      // the new version of this widget. We're essentially trying to replace one
      // level in the prototype chain.
      if ( existingConstructor ) {
          $.each( existingConstructor._childConstructors, function( i, child ) {
              var childPrototype = child.prototype;
  
              // redefine the child widget using the same prototype that was
              // originally used, but inherit from the new version of the base
              $.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto );
          });
          // remove the list of existing child constructors from the old constructor
          // so the old child constructors can be garbage collected
          delete existingConstructor._childConstructors;
      } else {
          base._childConstructors.push( constructor );
      }
  
      $.widget.bridge( name, constructor );
  
      return constructor;
  };
  
  $.widget.extend = function( target ) {
      var input = widget_slice.call( arguments, 1 ),
          inputIndex = 0,
          inputLength = input.length,
          key,
          value;
      for ( ; inputIndex < inputLength; inputIndex++ ) {
          for ( key in input[ inputIndex ] ) {
              value = input[ inputIndex ][ key ];
              if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
                  // Clone objects
                  if ( $.isPlainObject( value ) ) {
                      target[ key ] = $.isPlainObject( target[ key ] ) ?
                          $.widget.extend( {}, target[ key ], value ) :
                          // Don't extend strings, arrays, etc. with objects
                          $.widget.extend( {}, value );
                  // Copy everything else by reference
                  } else {
                      target[ key ] = value;
                  }
              }
          }
      }
      return target;
  };
  
  $.widget.bridge = function( name, object ) {
      var fullName = object.prototype.widgetFullName || name;
      $.fn[ name ] = function( options ) {
          var isMethodCall = typeof options === "string",
              args = widget_slice.call( arguments, 1 ),
              returnValue = this;
  
          if ( isMethodCall ) {
              this.each(function() {
                  var methodValue,
                      instance = $.data( this, fullName );
                  if ( options === "instance" ) {
                      returnValue = instance;
                      return false;
                  }
                  if ( !instance ) {
                      return $.error( "cannot call methods on " + name + " prior to initialization; " +
                          "attempted to call method '" + options + "'" );
                  }
                  if ( !$.isFunction( instance[options] ) || options.charAt( 0 ) === "_" ) {
                      return $.error( "no such method '" + options + "' for " + name + " widget instance" );
                  }
                  methodValue = instance[ options ].apply( instance, args );
                  if ( methodValue !== instance && methodValue !== undefined ) {
                      returnValue = methodValue && methodValue.jquery ?
                          returnValue.pushStack( methodValue.get() ) :
                          methodValue;
                      return false;
                  }
              });
          } else {
  
              // Allow multiple hashes to be passed on init
              if ( args.length ) {
                  options = $.widget.extend.apply( null, [ options ].concat(args) );
              }
  
              this.each(function() {
                  var instance = $.data( this, fullName );
                  if ( instance ) {
                      instance.option( options || {} );
                      if ( instance._init ) {
                          instance._init();
                      }
                  } else {
                      $.data( this, fullName, new object( options, this ) );
                  }
              });
          }
  
          return returnValue;
      };
  };
  
  $.Widget = function( /* options, element */ ) {};
  $.Widget._childConstructors = [];
  
  $.Widget.prototype = {
      widgetName: "widget",
      widgetEventPrefix: "",
      defaultElement: "<div>",
      options: {
          disabled: false,
  
          // callbacks
          create: null
      },
      _createWidget: function( options, element ) {
          element = $( element || this.defaultElement || this )[ 0 ];
          this.element = $( element );
          this.uuid = widget_uuid++;
          this.eventNamespace = "." + this.widgetName + this.uuid;
  
          this.bindings = $();
          this.hoverable = $();
          this.focusable = $();
  
          if ( element !== this ) {
              $.data( element, this.widgetFullName, this );
              this._on( true, this.element, {
                  remove: function( event ) {
                      if ( event.target === element ) {
                          this.destroy();
                      }
                  }
              });
              this.document = $( element.style ?
                  // element within the document
                  element.ownerDocument :
                  // element is window or document
                  element.document || element );
              this.window = $( this.document[0].defaultView || this.document[0].parentWindow );
          }
  
          this.options = $.widget.extend( {},
              this.options,
              this._getCreateOptions(),
              options );
  
          this._create();
          this._trigger( "create", null, this._getCreateEventData() );
          this._init();
      },
      _getCreateOptions: $.noop,
      _getCreateEventData: $.noop,
      _create: $.noop,
      _init: $.noop,
  
      destroy: function() {
          this._destroy();
          // we can probably remove the unbind calls in 2.0
          // all event bindings should go through this._on()
          this.element
              .unbind( this.eventNamespace )
              .removeData( this.widgetFullName )
              // support: jquery <1.6.3
              // http://bugs.jquery.com/ticket/9413
              .removeData( $.camelCase( this.widgetFullName ) );
          this.widget()
              .unbind( this.eventNamespace )
              .removeAttr( "aria-disabled" )
              .removeClass(
                  this.widgetFullName + "-disabled " +
                  "ui-state-disabled" );
  
          // clean up events and states
          this.bindings.unbind( this.eventNamespace );
          this.hoverable.removeClass( "ui-state-hover" );
          this.focusable.removeClass( "ui-state-focus" );
      },
      _destroy: $.noop,
  
      widget: function() {
          return this.element;
      },
  
      option: function( key, value ) {
          var options = key,
              parts,
              curOption,
              i;
  
          if ( arguments.length === 0 ) {
              // don't return a reference to the internal hash
              return $.widget.extend( {}, this.options );
          }
  
          if ( typeof key === "string" ) {
              // handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
              options = {};
              parts = key.split( "." );
              key = parts.shift();
              if ( parts.length ) {
                  curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
                  for ( i = 0; i < parts.length - 1; i++ ) {
                      curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
                      curOption = curOption[ parts[ i ] ];
                  }
                  key = parts.pop();
                  if ( arguments.length === 1 ) {
                      return curOption[ key ] === undefined ? null : curOption[ key ];
                  }
                  curOption[ key ] = value;
              } else {
                  if ( arguments.length === 1 ) {
                      return this.options[ key ] === undefined ? null : this.options[ key ];
                  }
                  options[ key ] = value;
              }
          }
  
          this._setOptions( options );
  
          return this;
      },
      _setOptions: function( options ) {
          var key;
  
          for ( key in options ) {
              this._setOption( key, options[ key ] );
          }
  
          return this;
      },
      _setOption: function( key, value ) {
          this.options[ key ] = value;
  
          if ( key === "disabled" ) {
              this.widget()
                  .toggleClass( this.widgetFullName + "-disabled", !!value );
  
              // If the widget is becoming disabled, then nothing is interactive
              if ( value ) {
                  this.hoverable.removeClass( "ui-state-hover" );
                  this.focusable.removeClass( "ui-state-focus" );
              }
          }
  
          return this;
      },
  
      enable: function() {
          return this._setOptions({ disabled: false });
      },
      disable: function() {
          return this._setOptions({ disabled: true });
      },
  
      _on: function( suppressDisabledCheck, element, handlers ) {
          var delegateElement,
              instance = this;
  
          // no suppressDisabledCheck flag, shuffle arguments
          if ( typeof suppressDisabledCheck !== "boolean" ) {
              handlers = element;
              element = suppressDisabledCheck;
              suppressDisabledCheck = false;
          }
  
          // no element argument, shuffle and use this.element
          if ( !handlers ) {
              handlers = element;
              element = this.element;
              delegateElement = this.widget();
          } else {
              element = delegateElement = $( element );
              this.bindings = this.bindings.add( element );
          }
  
          $.each( handlers, function( event, handler ) {
              function handlerProxy() {
                  // allow widgets to customize the disabled handling
                  // - disabled as an array instead of boolean
                  // - disabled class as method for disabling individual parts
                  if ( !suppressDisabledCheck &&
                          ( instance.options.disabled === true ||
                              $( this ).hasClass( "ui-state-disabled" ) ) ) {
                      return;
                  }
                  return ( typeof handler === "string" ? instance[ handler ] : handler )
                      .apply( instance, arguments );
              }
  
              // copy the guid so direct unbinding works
              if ( typeof handler !== "string" ) {
                  handlerProxy.guid = handler.guid =
                      handler.guid || handlerProxy.guid || $.guid++;
              }
  
              var match = event.match( /^([\w:-]*)\s*(.*)$/ ),
                  eventName = match[1] + instance.eventNamespace,
                  selector = match[2];
              if ( selector ) {
                  delegateElement.delegate( selector, eventName, handlerProxy );
              } else {
                  element.bind( eventName, handlerProxy );
              }
          });
      },
  
      _off: function( element, eventName ) {
          eventName = (eventName || "").split( " " ).join( this.eventNamespace + " " ) +
              this.eventNamespace;
          element.unbind( eventName ).undelegate( eventName );
  
          // Clear the stack to avoid memory leaks (#10056)
          this.bindings = $( this.bindings.not( element ).get() );
          this.focusable = $( this.focusable.not( element ).get() );
          this.hoverable = $( this.hoverable.not( element ).get() );
      },
  
      _delay: function( handler, delay ) {
          function handlerProxy() {
              return ( typeof handler === "string" ? instance[ handler ] : handler )
                  .apply( instance, arguments );
          }
          var instance = this;
          return setTimeout( handlerProxy, delay || 0 );
      },
  
      _hoverable: function( element ) {
          this.hoverable = this.hoverable.add( element );
          this._on( element, {
              mouseenter: function( event ) {
                  $( event.currentTarget ).addClass( "ui-state-hover" );
              },
              mouseleave: function( event ) {
                  $( event.currentTarget ).removeClass( "ui-state-hover" );
              }
          });
      },
  
      _focusable: function( element ) {
          this.focusable = this.focusable.add( element );
          this._on( element, {
              focusin: function( event ) {
                  $( event.currentTarget ).addClass( "ui-state-focus" );
              },
              focusout: function( event ) {
                  $( event.currentTarget ).removeClass( "ui-state-focus" );
              }
          });
      },
  
      _trigger: function( type, event, data ) {
          var prop, orig,
              callback = this.options[ type ];
  
          data = data || {};
          event = $.Event( event );
          event.type = ( type === this.widgetEventPrefix ?
              type :
              this.widgetEventPrefix + type ).toLowerCase();
          // the original event may come from any element
          // so we need to reset the target on the new event
          event.target = this.element[ 0 ];
  
          // copy original event properties over to the new event
          orig = event.originalEvent;
          if ( orig ) {
              for ( prop in orig ) {
                  if ( !( prop in event ) ) {
                      event[ prop ] = orig[ prop ];
                  }
              }
          }
  
          this.element.trigger( event, data );
          return !( $.isFunction( callback ) &&
              callback.apply( this.element[0], [ event ].concat( data ) ) === false ||
              event.isDefaultPrevented() );
      }
  };
  
  $.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
      $.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
          if ( typeof options === "string" ) {
              options = { effect: options };
          }
          var hasOptions,
              effectName = !options ?
                  method :
                  options === true || typeof options === "number" ?
                      defaultEffect :
                      options.effect || defaultEffect;
          options = options || {};
          if ( typeof options === "number" ) {
              options = { duration: options };
          }
          hasOptions = !$.isEmptyObject( options );
          options.complete = callback;
          if ( options.delay ) {
              element.delay( options.delay );
          }
          if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
              element[ method ]( options );
          } else if ( effectName !== method && element[ effectName ] ) {
              element[ effectName ]( options.duration, options.easing, callback );
          } else {
              element.queue(function( next ) {
                  $( this )[ method ]();
                  if ( callback ) {
                      callback.call( element[ 0 ] );
                  }
                  next();
              });
          }
      };
  });
  
  var widget = $.widget;
  
  
  /*!
   * jQuery UI Button 1.11.4
   * http://jqueryui.com
   *
   * Copyright jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/button/
   */
  
  
  var lastActive,
      baseClasses = "ui-button ui-widget ui-state-default ui-corner-all",
      typeClasses = "ui-button-icons-only ui-button-icon-only ui-button-text-icons ui-button-text-icon-primary ui-button-text-icon-secondary ui-button-text-only",
      formResetHandler = function() {
          var form = $( this );
          setTimeout(function() {
              form.find( ":ui-button" ).button( "refresh" );
          }, 1 );
      },
      radioGroup = function( radio ) {
          var name = radio.name,
              form = radio.form,
              radios = $( [] );
          if ( name ) {
              name = name.replace( /'/g, "\\'" );
              if ( form ) {
                  radios = $( form ).find( "[name='" + name + "'][type=radio]" );
              } else {
                  radios = $( "[name='" + name + "'][type=radio]", radio.ownerDocument )
                      .filter(function() {
                          return !this.form;
                      });
              }
          }
          return radios;
      };
  
  $.widget( "ui.button", {
      version: "1.11.4",
      defaultElement: "<button>",
      options: {
          disabled: null,
          text: true,
          label: null,
          icons: {
              primary: null,
              secondary: null
          }
      },
      _create: function() {
          this.element.closest( "form" )
              .unbind( "reset" + this.eventNamespace )
              .bind( "reset" + this.eventNamespace, formResetHandler );
  
          if ( typeof this.options.disabled !== "boolean" ) {
              this.options.disabled = !!this.element.prop( "disabled" );
          } else {
              this.element.prop( "disabled", this.options.disabled );
          }
  
          this._determineButtonType();
          this.hasTitle = !!this.buttonElement.attr( "title" );
  
          var that = this,
              options = this.options,
              toggleButton = this.type === "checkbox" || this.type === "radio",
              activeClass = !toggleButton ? "ui-state-active" : "";
  
          if ( options.label === null ) {
              options.label = (this.type === "input" ? this.buttonElement.val() : this.buttonElement.html());
          }
  
          this._hoverable( this.buttonElement );
  
          this.buttonElement
              .addClass( baseClasses )
              .attr( "role", "button" )
              .bind( "mouseenter" + this.eventNamespace, function() {
                  if ( options.disabled ) {
                      return;
                  }
                  if ( this === lastActive ) {
                      $( this ).addClass( "ui-state-active" );
                  }
              })
              .bind( "mouseleave" + this.eventNamespace, function() {
                  if ( options.disabled ) {
                      return;
                  }
                  $( this ).removeClass( activeClass );
              })
              .bind( "click" + this.eventNamespace, function( event ) {
                  if ( options.disabled ) {
                      event.preventDefault();
                      event.stopImmediatePropagation();
                  }
              });
  
          // Can't use _focusable() because the element that receives focus
          // and the element that gets the ui-state-focus class are different
          this._on({
              focus: function() {
                  this.buttonElement.addClass( "ui-state-focus" );
              },
              blur: function() {
                  this.buttonElement.removeClass( "ui-state-focus" );
              }
          });
  
          if ( toggleButton ) {
              this.element.bind( "change" + this.eventNamespace, function() {
                  that.refresh();
              });
          }
  
          if ( this.type === "checkbox" ) {
              this.buttonElement.bind( "click" + this.eventNamespace, function() {
                  if ( options.disabled ) {
                      return false;
                  }
              });
          } else if ( this.type === "radio" ) {
              this.buttonElement.bind( "click" + this.eventNamespace, function() {
                  if ( options.disabled ) {
                      return false;
                  }
                  $( this ).addClass( "ui-state-active" );
                  that.buttonElement.attr( "aria-pressed", "true" );
  
                  var radio = that.element[ 0 ];
                  radioGroup( radio )
                      .not( radio )
                      .map(function() {
                          return $( this ).button( "widget" )[ 0 ];
                      })
                      .removeClass( "ui-state-active" )
                      .attr( "aria-pressed", "false" );
              });
          } else {
              this.buttonElement
                  .bind( "mousedown" + this.eventNamespace, function() {
                      if ( options.disabled ) {
                          return false;
                      }
                      $( this ).addClass( "ui-state-active" );
                      lastActive = this;
                      that.document.one( "mouseup", function() {
                          lastActive = null;
                      });
                  })
                  .bind( "mouseup" + this.eventNamespace, function() {
                      if ( options.disabled ) {
                          return false;
                      }
                      $( this ).removeClass( "ui-state-active" );
                  })
                  .bind( "keydown" + this.eventNamespace, function(event) {
                      if ( options.disabled ) {
                          return false;
                      }
                      if ( event.keyCode === $.ui.keyCode.SPACE || event.keyCode === $.ui.keyCode.ENTER ) {
                          $( this ).addClass( "ui-state-active" );
                      }
                  })
                  // see #8559, we bind to blur here in case the button element loses
                  // focus between keydown and keyup, it would be left in an "active" state
                  .bind( "keyup" + this.eventNamespace + " blur" + this.eventNamespace, function() {
                      $( this ).removeClass( "ui-state-active" );
                  });
  
              if ( this.buttonElement.is("a") ) {
                  this.buttonElement.keyup(function(event) {
                      if ( event.keyCode === $.ui.keyCode.SPACE ) {
                          // TODO pass through original event correctly (just as 2nd argument doesn't work)
                          $( this ).click();
                      }
                  });
              }
          }
  
          this._setOption( "disabled", options.disabled );
          this._resetButton();
      },
  
      _determineButtonType: function() {
          var ancestor, labelSelector, checked;
  
          if ( this.element.is("[type=checkbox]") ) {
              this.type = "checkbox";
          } else if ( this.element.is("[type=radio]") ) {
              this.type = "radio";
          } else if ( this.element.is("input") ) {
              this.type = "input";
          } else {
              this.type = "button";
          }
  
          if ( this.type === "checkbox" || this.type === "radio" ) {
              // we don't search against the document in case the element
              // is disconnected from the DOM
              ancestor = this.element.parents().last();
              labelSelector = "label[for='" + this.element.attr("id") + "']";
              this.buttonElement = ancestor.find( labelSelector );
              if ( !this.buttonElement.length ) {
                  ancestor = ancestor.length ? ancestor.siblings() : this.element.siblings();
                  this.buttonElement = ancestor.filter( labelSelector );
                  if ( !this.buttonElement.length ) {
                      this.buttonElement = ancestor.find( labelSelector );
                  }
              }
              this.element.addClass( "ui-helper-hidden-accessible" );
  
              checked = this.element.is( ":checked" );
              if ( checked ) {
                  this.buttonElement.addClass( "ui-state-active" );
              }
              this.buttonElement.prop( "aria-pressed", checked );
          } else {
              this.buttonElement = this.element;
          }
      },
  
      widget: function() {
          return this.buttonElement;
      },
  
      _destroy: function() {
          this.element
              .removeClass( "ui-helper-hidden-accessible" );
          this.buttonElement
              .removeClass( baseClasses + " ui-state-active " + typeClasses )
              .removeAttr( "role" )
              .removeAttr( "aria-pressed" )
              .html( this.buttonElement.find(".ui-button-text").html() );
  
          if ( !this.hasTitle ) {
              this.buttonElement.removeAttr( "title" );
          }
      },
  
      _setOption: function( key, value ) {
          this._super( key, value );
          if ( key === "disabled" ) {
              this.widget().toggleClass( "ui-state-disabled", !!value );
              this.element.prop( "disabled", !!value );
              if ( value ) {
                  if ( this.type === "checkbox" || this.type === "radio" ) {
                      this.buttonElement.removeClass( "ui-state-focus" );
                  } else {
                      this.buttonElement.removeClass( "ui-state-focus ui-state-active" );
                  }
              }
              return;
          }
          this._resetButton();
      },
  
      refresh: function() {
          //See #8237 & #8828
          var isDisabled = this.element.is( "input, button" ) ? this.element.is( ":disabled" ) : this.element.hasClass( "ui-button-disabled" );
  
          if ( isDisabled !== this.options.disabled ) {
              this._setOption( "disabled", isDisabled );
          }
          if ( this.type === "radio" ) {
              radioGroup( this.element[0] ).each(function() {
                  if ( $( this ).is( ":checked" ) ) {
                      $( this ).button( "widget" )
                          .addClass( "ui-state-active" )
                          .attr( "aria-pressed", "true" );
                  } else {
                      $( this ).button( "widget" )
                          .removeClass( "ui-state-active" )
                          .attr( "aria-pressed", "false" );
                  }
              });
          } else if ( this.type === "checkbox" ) {
              if ( this.element.is( ":checked" ) ) {
                  this.buttonElement
                      .addClass( "ui-state-active" )
                      .attr( "aria-pressed", "true" );
              } else {
                  this.buttonElement
                      .removeClass( "ui-state-active" )
                      .attr( "aria-pressed", "false" );
              }
          }
      },
  
      _resetButton: function() {
          if ( this.type === "input" ) {
              if ( this.options.label ) {
                  this.element.val( this.options.label );
              }
              return;
          }
          var buttonElement = this.buttonElement.removeClass( typeClasses ),
              buttonText = $( "<span></span>", this.document[0] )
                  .addClass( "ui-button-text" )
                  .html( this.options.label )
                  .appendTo( buttonElement.empty() )
                  .text(),
              icons = this.options.icons,
              multipleIcons = icons.primary && icons.secondary,
              buttonClasses = [];
  
          if ( icons.primary || icons.secondary ) {
              if ( this.options.text ) {
                  buttonClasses.push( "ui-button-text-icon" + ( multipleIcons ? "s" : ( icons.primary ? "-primary" : "-secondary" ) ) );
              }
  
              if ( icons.primary ) {
                  buttonElement.prepend( "<span class='ui-button-icon-primary ui-icon " + icons.primary + "'></span>" );
              }
  
              if ( icons.secondary ) {
                  buttonElement.append( "<span class='ui-button-icon-secondary ui-icon " + icons.secondary + "'></span>" );
              }
  
              if ( !this.options.text ) {
                  buttonClasses.push( multipleIcons ? "ui-button-icons-only" : "ui-button-icon-only" );
  
                  if ( !this.hasTitle ) {
                      buttonElement.attr( "title", $.trim( buttonText ) );
                  }
              }
          } else {
              buttonClasses.push( "ui-button-text-only" );
          }
          buttonElement.addClass( buttonClasses.join( " " ) );
      }
  });
  
  $.widget( "ui.buttonset", {
      version: "1.11.4",
      options: {
          items: "button, input[type=button], input[type=submit], input[type=reset], input[type=checkbox], input[type=radio], a, :data(ui-button)"
      },
  
      _create: function() {
          this.element.addClass( "ui-buttonset" );
      },
  
      _init: function() {
          this.refresh();
      },
  
      _setOption: function( key, value ) {
          if ( key === "disabled" ) {
              this.buttons.button( "option", key, value );
          }
  
          this._super( key, value );
      },
  
      refresh: function() {
          var rtl = this.element.css( "direction" ) === "rtl",
              allButtons = this.element.find( this.options.items ),
              existingButtons = allButtons.filter( ":ui-button" );
  
          // Initialize new buttons
          allButtons.not( ":ui-button" ).button();
  
          // Refresh existing buttons
          existingButtons.button( "refresh" );
  
          this.buttons = allButtons
              .map(function() {
                  return $( this ).button( "widget" )[ 0 ];
              })
                  .removeClass( "ui-corner-all ui-corner-left ui-corner-right" )
                  .filter( ":first" )
                      .addClass( rtl ? "ui-corner-right" : "ui-corner-left" )
                  .end()
                  .filter( ":last" )
                      .addClass( rtl ? "ui-corner-left" : "ui-corner-right" )
                  .end()
              .end();
      },
  
      _destroy: function() {
          this.element.removeClass( "ui-buttonset" );
          this.buttons
              .map(function() {
                  return $( this ).button( "widget" )[ 0 ];
              })
                  .removeClass( "ui-corner-left ui-corner-right" )
              .end()
              .button( "destroy" );
      }
  });
  
  var button = $.ui.button;
  
  
  /*!
   * jQuery UI Spinner 1.11.4
   * http://jqueryui.com
   *
   * Copyright jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/spinner/
   */
  
  
  function spinner_modifier( fn ) {
      return function() {
          var previous = this.element.val();
          fn.apply( this, arguments );
          this._refresh();
          if ( previous !== this.element.val() ) {
              this._trigger( "change" );
          }
      };
  }
  
  var spinner = $.widget( "ui.spinner", {
      version: "1.11.4",
      defaultElement: "<input>",
      widgetEventPrefix: "spin",
      options: {
          culture: null,
          icons: {
              down: "ui-icon-triangle-1-s",
              up: "ui-icon-triangle-1-n"
          },
          incremental: true,
          max: null,
          min: null,
          numberFormat: null,
          page: 10,
          step: 1,
  
          change: null,
          spin: null,
          start: null,
          stop: null
      },
  
      _create: function() {
          // handle string values that need to be parsed
          this._setOption( "max", this.options.max );
          this._setOption( "min", this.options.min );
          this._setOption( "step", this.options.step );
  
          // Only format if there is a value, prevents the field from being marked
          // as invalid in Firefox, see #9573.
          if ( this.value() !== "" ) {
              // Format the value, but don't constrain.
              this._value( this.element.val(), true );
          }
  
          this._draw();
          this._on( this._events );
          this._refresh();
  
          // turning off autocomplete prevents the browser from remembering the
          // value when navigating through history, so we re-enable autocomplete
          // if the page is unloaded before the widget is destroyed. #7790
          this._on( this.window, {
              beforeunload: function() {
                  this.element.removeAttr( "autocomplete" );
              }
          });
      },
  
      _getCreateOptions: function() {
          var options = {},
              element = this.element;
  
          $.each( [ "min", "max", "step" ], function( i, option ) {
              var value = element.attr( option );
              if ( value !== undefined && value.length ) {
                  options[ option ] = value;
              }
          });
  
          return options;
      },
  
      _events: {
          keydown: function( event ) {
              if ( this._start( event ) && this._keydown( event ) ) {
                  event.preventDefault();
              }
          },
          keyup: "_stop",
          focus: function() {
              this.previous = this.element.val();
          },
          blur: function( event ) {
              if ( this.cancelBlur ) {
                  delete this.cancelBlur;
                  return;
              }
  
              this._stop();
              this._refresh();
              if ( this.previous !== this.element.val() ) {
                  this._trigger( "change", event );
              }
          },
          mousewheel: function( event, delta ) {
              if ( !delta ) {
                  return;
              }
              if ( !this.spinning && !this._start( event ) ) {
                  return false;
              }
  
              this._spin( (delta > 0 ? 1 : -1) * this.options.step, event );
              clearTimeout( this.mousewheelTimer );
              this.mousewheelTimer = this._delay(function() {
                  if ( this.spinning ) {
                      this._stop( event );
                  }
              }, 100 );
              event.preventDefault();
          },
          "mousedown .ui-spinner-button": function( event ) {
              var previous;
  
              // We never want the buttons to have focus; whenever the user is
              // interacting with the spinner, the focus should be on the input.
              // If the input is focused then this.previous is properly set from
              // when the input first received focus. If the input is not focused
              // then we need to set this.previous based on the value before spinning.
              previous = this.element[0] === this.document[0].activeElement ?
                  this.previous : this.element.val();
              function checkFocus() {
                  var isActive = this.element[0] === this.document[0].activeElement;
                  if ( !isActive ) {
                      this.element.focus();
                      this.previous = previous;
                      // support: IE
                      // IE sets focus asynchronously, so we need to check if focus
                      // moved off of the input because the user clicked on the button.
                      this._delay(function() {
                          this.previous = previous;
                      });
                  }
              }
  
              // ensure focus is on (or stays on) the text field
              event.preventDefault();
              checkFocus.call( this );
  
              // support: IE
              // IE doesn't prevent moving focus even with event.preventDefault()
              // so we set a flag to know when we should ignore the blur event
              // and check (again) if focus moved off of the input.
              this.cancelBlur = true;
              this._delay(function() {
                  delete this.cancelBlur;
                  checkFocus.call( this );
              });
  
              if ( this._start( event ) === false ) {
                  return;
              }
  
              this._repeat( null, $( event.currentTarget ).hasClass( "ui-spinner-up" ) ? 1 : -1, event );
          },
          "mouseup .ui-spinner-button": "_stop",
          "mouseenter .ui-spinner-button": function( event ) {
              // button will add ui-state-active if mouse was down while mouseleave and kept down
              if ( !$( event.currentTarget ).hasClass( "ui-state-active" ) ) {
                  return;
              }
  
              if ( this._start( event ) === false ) {
                  return false;
              }
              this._repeat( null, $( event.currentTarget ).hasClass( "ui-spinner-up" ) ? 1 : -1, event );
          },
          // TODO: do we really want to consider this a stop?
          // shouldn't we just stop the repeater and wait until mouseup before
          // we trigger the stop event?
          "mouseleave .ui-spinner-button": "_stop"
      },
  
      _draw: function() {
          var uiSpinner = this.uiSpinner = this.element
              .addClass( "ui-spinner-input" )
              .attr( "autocomplete", "off" )
              .wrap( this._uiSpinnerHtml() )
              .parent()
                  // add buttons
                  .append( this._buttonHtml() );
  
          this.element.attr( "role", "spinbutton" );
  
          // button bindings
          this.buttons = uiSpinner.find( ".ui-spinner-button" )
              .attr( "tabIndex", -1 )
              .button()
              .removeClass( "ui-corner-all" );
  
          // IE 6 doesn't understand height: 50% for the buttons
          // unless the wrapper has an explicit height
          if ( this.buttons.height() > Math.ceil( uiSpinner.height() * 0.5 ) &&
                  uiSpinner.height() > 0 ) {
              uiSpinner.height( uiSpinner.height() );
          }
  
          // disable spinner if element was already disabled
          if ( this.options.disabled ) {
              this.disable();
          }
      },
  
      _keydown: function( event ) {
          var options = this.options,
              keyCode = $.ui.keyCode;
  
          switch ( event.keyCode ) {
          case keyCode.UP:
              this._repeat( null, 1, event );
              return true;
          case keyCode.DOWN:
              this._repeat( null, -1, event );
              return true;
          case keyCode.PAGE_UP:
              this._repeat( null, options.page, event );
              return true;
          case keyCode.PAGE_DOWN:
              this._repeat( null, -options.page, event );
              return true;
          }
  
          return false;
      },
  
      _uiSpinnerHtml: function() {
          return "<span class='ui-spinner ui-widget ui-widget-content ui-corner-all'></span>";
      },
  
      _buttonHtml: function() {
          return "" +
              "<a class='ui-spinner-button ui-spinner-up ui-corner-tr'>" +
                  "<span class='ui-icon " + this.options.icons.up + "'>&#9650;</span>" +
              "</a>" +
              "<a class='ui-spinner-button ui-spinner-down ui-corner-br'>" +
                  "<span class='ui-icon " + this.options.icons.down + "'>&#9660;</span>" +
              "</a>";
      },
  
      _start: function( event ) {
          if ( !this.spinning && this._trigger( "start", event ) === false ) {
              return false;
          }
  
          if ( !this.counter ) {
              this.counter = 1;
          }
          this.spinning = true;
          return true;
      },
  
      _repeat: function( i, steps, event ) {
          i = i || 500;
  
          clearTimeout( this.timer );
          this.timer = this._delay(function() {
              this._repeat( 40, steps, event );
          }, i );
  
          this._spin( steps * this.options.step, event );
      },
  
      _spin: function( step, event ) {
          var value = this.value() || 0;
  
          if ( !this.counter ) {
              this.counter = 1;
          }
  
          value = this._adjustValue( value + step * this._increment( this.counter ) );
  
          if ( !this.spinning || this._trigger( "spin", event, { value: value } ) !== false) {
              this._value( value );
              this.counter++;
          }
      },
  
      _increment: function( i ) {
          var incremental = this.options.incremental;
  
          if ( incremental ) {
              return $.isFunction( incremental ) ?
                  incremental( i ) :
                  Math.floor( i * i * i / 50000 - i * i / 500 + 17 * i / 200 + 1 );
          }
  
          return 1;
      },
  
      _precision: function() {
          var precision = this._precisionOf( this.options.step );
          if ( this.options.min !== null ) {
              precision = Math.max( precision, this._precisionOf( this.options.min ) );
          }
          return precision;
      },
  
      _precisionOf: function( num ) {
          var str = num.toString(),
              decimal = str.indexOf( "." );
          return decimal === -1 ? 0 : str.length - decimal - 1;
      },
  
      _adjustValue: function( value ) {
          var base, aboveMin,
              options = this.options;
  
          // make sure we're at a valid step
          // - find out where we are relative to the base (min or 0)
          base = options.min !== null ? options.min : 0;
          aboveMin = value - base;
          // - round to the nearest step
          aboveMin = Math.round(aboveMin / options.step) * options.step;
          // - rounding is based on 0, so adjust back to our base
          value = base + aboveMin;
  
          // fix precision from bad JS floating point math
          value = parseFloat( value.toFixed( this._precision() ) );
  
          // clamp the value
          if ( options.max !== null && value > options.max) {
              return options.max;
          }
          if ( options.min !== null && value < options.min ) {
              return options.min;
          }
  
          return value;
      },
  
      _stop: function( event ) {
          if ( !this.spinning ) {
              return;
          }
  
          clearTimeout( this.timer );
          clearTimeout( this.mousewheelTimer );
          this.counter = 0;
          this.spinning = false;
          this._trigger( "stop", event );
      },
  
      _setOption: function( key, value ) {
          if ( key === "culture" || key === "numberFormat" ) {
              var prevValue = this._parse( this.element.val() );
              this.options[ key ] = value;
              this.element.val( this._format( prevValue ) );
              return;
          }
  
          if ( key === "max" || key === "min" || key === "step" ) {
              if ( typeof value === "string" ) {
                  value = this._parse( value );
              }
          }
          if ( key === "icons" ) {
              this.buttons.first().find( ".ui-icon" )
                  .removeClass( this.options.icons.up )
                  .addClass( value.up );
              this.buttons.last().find( ".ui-icon" )
                  .removeClass( this.options.icons.down )
                  .addClass( value.down );
          }
  
          this._super( key, value );
  
          if ( key === "disabled" ) {
              this.widget().toggleClass( "ui-state-disabled", !!value );
              this.element.prop( "disabled", !!value );
              this.buttons.button( value ? "disable" : "enable" );
          }
      },
  
      _setOptions: spinner_modifier(function( options ) {
          this._super( options );
      }),
  
      _parse: function( val ) {
          if ( typeof val === "string" && val !== "" ) {
              val = window.Globalize && this.options.numberFormat ?
                  Globalize.parseFloat( val, 10, this.options.culture ) : +val;
          }
          return val === "" || isNaN( val ) ? null : val;
      },
  
      _format: function( value ) {
          if ( value === "" ) {
              return "";
          }
          return window.Globalize && this.options.numberFormat ?
              Globalize.format( value, this.options.numberFormat, this.options.culture ) :
              value;
      },
  
      _refresh: function() {
          this.element.attr({
              "aria-valuemin": this.options.min,
              "aria-valuemax": this.options.max,
              // TODO: what should we do with values that can't be parsed?
              "aria-valuenow": this._parse( this.element.val() )
          });
      },
  
      isValid: function() {
          var value = this.value();
  
          // null is invalid
          if ( value === null ) {
              return false;
          }
  
          // if value gets adjusted, it's invalid
          return value === this._adjustValue( value );
      },
  
      // update the value without triggering change
      _value: function( value, allowAny ) {
          var parsed;
          if ( value !== "" ) {
              parsed = this._parse( value );
              if ( parsed !== null ) {
                  if ( !allowAny ) {
                      parsed = this._adjustValue( parsed );
                  }
                  value = this._format( parsed );
              }
          }
          this.element.val( value );
          this._refresh();
      },
  
      _destroy: function() {
          this.element
              .removeClass( "ui-spinner-input" )
              .prop( "disabled", false )
              .removeAttr( "autocomplete" )
              .removeAttr( "role" )
              .removeAttr( "aria-valuemin" )
              .removeAttr( "aria-valuemax" )
              .removeAttr( "aria-valuenow" );
          this.uiSpinner.replaceWith( this.element );
      },
  
      stepUp: spinner_modifier(function( steps ) {
          this._stepUp( steps );
      }),
      _stepUp: function( steps ) {
          if ( this._start() ) {
              this._spin( (steps || 1) * this.options.step );
              this._stop();
          }
      },
  
      stepDown: spinner_modifier(function( steps ) {
          this._stepDown( steps );
      }),
      _stepDown: function( steps ) {
          if ( this._start() ) {
              this._spin( (steps || 1) * -this.options.step );
              this._stop();
          }
      },
  
      pageUp: spinner_modifier(function( pages ) {
          this._stepUp( (pages || 1) * this.options.page );
      }),
  
      pageDown: spinner_modifier(function( pages ) {
          this._stepDown( (pages || 1) * this.options.page );
      }),
  
      value: function( newVal ) {
          if ( !arguments.length ) {
              return this._parse( this.element.val() );
          }
          spinner_modifier( this._value ).call( this, newVal );
      },
  
      widget: function() {
          return this.uiSpinner;
      }
  });
  
  
  
  }));
/*!
* mustache.js - Logic-less {{mustache}} templates with JavaScript
* http://github.com/janl/mustache.js
*/
/*global define: false Mustache: true*/

(function defineMustache(global,factory){if(typeof define==="function"&&define.amd){define(["exports"],factory)}else{global.Mustache=global.Mustache||{};factory(global.Mustache)}})(typeof window!=="undefined"?window:this,function mustacheFactory(mustache){var objectToString=Object.prototype.toString;var isArray=Array.isArray||function isArrayPolyfill(object){return objectToString.call(object)==="[object Array]"};function isFunction(object){return typeof object==="function"}function typeStr(obj){return isArray(obj)?"array":typeof obj}function escapeRegExp(string){return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")}function hasProperty(obj,propName){return obj!=null&&typeof obj==="object"&&propName in obj}function primitiveHasOwnProperty(primitive,propName){return primitive!=null&&typeof primitive!=="object"&&primitive.hasOwnProperty&&primitive.hasOwnProperty(propName)}var regExpTest=RegExp.prototype.test;function testRegExp(re,string){return regExpTest.call(re,string)}var nonSpaceRe=/\S/;function isWhitespace(string){return!testRegExp(nonSpaceRe,string)}var entityMap={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#x2F;","`":"&#x60;","=":"&#x3D;"};function escapeHtml(string){return String(string).replace(/[&<>"'`=\/]/g,function fromEntityMap(s){return entityMap[s]})}var whiteRe=/\s*/;var spaceRe=/\s+/;var equalsRe=/\s*=/;var curlyRe=/\s*\}/;var tagRe=/#|\^|\/|>|\{|&|=|!/;function parseTemplate(template,tags){if(!template)return[];var sections=[];var tokens=[];var spaces=[];var hasTag=false;var nonSpace=false;function stripSpace(){if(hasTag&&!nonSpace){while(spaces.length)delete tokens[spaces.pop()]}else{spaces=[]}hasTag=false;nonSpace=false}var openingTagRe,closingTagRe,closingCurlyRe;function compileTags(tagsToCompile){if(typeof tagsToCompile==="string")tagsToCompile=tagsToCompile.split(spaceRe,2);if(!isArray(tagsToCompile)||tagsToCompile.length!==2)throw new Error("Invalid tags: "+tagsToCompile);openingTagRe=new RegExp(escapeRegExp(tagsToCompile[0])+"\\s*");closingTagRe=new RegExp("\\s*"+escapeRegExp(tagsToCompile[1]));closingCurlyRe=new RegExp("\\s*"+escapeRegExp("}"+tagsToCompile[1]))}compileTags(tags||mustache.tags);var scanner=new Scanner(template);var start,type,value,chr,token,openSection;while(!scanner.eos()){start=scanner.pos;value=scanner.scanUntil(openingTagRe);if(value){for(var i=0,valueLength=value.length;i<valueLength;++i){chr=value.charAt(i);if(isWhitespace(chr)){spaces.push(tokens.length)}else{nonSpace=true}tokens.push(["text",chr,start,start+1]);start+=1;if(chr==="\n")stripSpace()}}if(!scanner.scan(openingTagRe))break;hasTag=true;type=scanner.scan(tagRe)||"name";scanner.scan(whiteRe);if(type==="="){value=scanner.scanUntil(equalsRe);scanner.scan(equalsRe);scanner.scanUntil(closingTagRe)}else if(type==="{"){value=scanner.scanUntil(closingCurlyRe);scanner.scan(curlyRe);scanner.scanUntil(closingTagRe);type="&"}else{value=scanner.scanUntil(closingTagRe)}if(!scanner.scan(closingTagRe))throw new Error("Unclosed tag at "+scanner.pos);token=[type,value,start,scanner.pos];tokens.push(token);if(type==="#"||type==="^"){sections.push(token)}else if(type==="/"){openSection=sections.pop();if(!openSection)throw new Error('Unopened section "'+value+'" at '+start);if(openSection[1]!==value)throw new Error('Unclosed section "'+openSection[1]+'" at '+start)}else if(type==="name"||type==="{"||type==="&"){nonSpace=true}else if(type==="="){compileTags(value)}}openSection=sections.pop();if(openSection)throw new Error('Unclosed section "'+openSection[1]+'" at '+scanner.pos);return nestTokens(squashTokens(tokens))}function squashTokens(tokens){var squashedTokens=[];var token,lastToken;for(var i=0,numTokens=tokens.length;i<numTokens;++i){token=tokens[i];if(token){if(token[0]==="text"&&lastToken&&lastToken[0]==="text"){lastToken[1]+=token[1];lastToken[3]=token[3]}else{squashedTokens.push(token);lastToken=token}}}return squashedTokens}function nestTokens(tokens){var nestedTokens=[];var collector=nestedTokens;var sections=[];var token,section;for(var i=0,numTokens=tokens.length;i<numTokens;++i){token=tokens[i];switch(token[0]){case"#":case"^":collector.push(token);sections.push(token);collector=token[4]=[];break;case"/":section=sections.pop();section[5]=token[2];collector=sections.length>0?sections[sections.length-1][4]:nestedTokens;break;default:collector.push(token)}}return nestedTokens}function Scanner(string){this.string=string;this.tail=string;this.pos=0}Scanner.prototype.eos=function eos(){return this.tail===""};Scanner.prototype.scan=function scan(re){var match=this.tail.match(re);if(!match||match.index!==0)return"";var string=match[0];this.tail=this.tail.substring(string.length);this.pos+=string.length;return string};Scanner.prototype.scanUntil=function scanUntil(re){var index=this.tail.search(re),match;switch(index){case-1:match=this.tail;this.tail="";break;case 0:match="";break;default:match=this.tail.substring(0,index);this.tail=this.tail.substring(index)}this.pos+=match.length;return match};function Context(view,parentContext){this.view=view;this.cache={".":this.view};this.parent=parentContext}Context.prototype.push=function push(view){return new Context(view,this)};Context.prototype.lookup=function lookup(name){var cache=this.cache;var value;if(cache.hasOwnProperty(name)){value=cache[name]}else{var context=this,intermediateValue,names,index,lookupHit=false;while(context){if(name.indexOf(".")>0){intermediateValue=context.view;names=name.split(".");index=0;while(intermediateValue!=null&&index<names.length){if(index===names.length-1)lookupHit=hasProperty(intermediateValue,names[index])||primitiveHasOwnProperty(intermediateValue,names[index]);intermediateValue=intermediateValue[names[index++]]}}else{intermediateValue=context.view[name];lookupHit=hasProperty(context.view,name)}if(lookupHit){value=intermediateValue;break}context=context.parent}cache[name]=value}if(isFunction(value))value=value.call(this.view);return value};function Writer(){this.cache={}}Writer.prototype.clearCache=function clearCache(){this.cache={}};Writer.prototype.parse=function parse(template,tags){var cache=this.cache;var cacheKey=template+":"+(tags||mustache.tags).join(":");var tokens=cache[cacheKey];if(tokens==null)tokens=cache[cacheKey]=parseTemplate(template,tags);return tokens};Writer.prototype.render=function render(template,view,partials,tags){var tokens=this.parse(template,tags);var context=view instanceof Context?view:new Context(view);return this.renderTokens(tokens,context,partials,template)};Writer.prototype.renderTokens=function renderTokens(tokens,context,partials,originalTemplate){var buffer="";var token,symbol,value;for(var i=0,numTokens=tokens.length;i<numTokens;++i){value=undefined;token=tokens[i];symbol=token[0];if(symbol==="#")value=this.renderSection(token,context,partials,originalTemplate);else if(symbol==="^")value=this.renderInverted(token,context,partials,originalTemplate);else if(symbol===">")value=this.renderPartial(token,context,partials,originalTemplate);else if(symbol==="&")value=this.unescapedValue(token,context);else if(symbol==="name")value=this.escapedValue(token,context);else if(symbol==="text")value=this.rawValue(token);if(value!==undefined)buffer+=value}return buffer};Writer.prototype.renderSection=function renderSection(token,context,partials,originalTemplate){var self=this;var buffer="";var value=context.lookup(token[1]);function subRender(template){return self.render(template,context,partials)}if(!value)return;if(isArray(value)){for(var j=0,valueLength=value.length;j<valueLength;++j){buffer+=this.renderTokens(token[4],context.push(value[j]),partials,originalTemplate)}}else if(typeof value==="object"||typeof value==="string"||typeof value==="number"){buffer+=this.renderTokens(token[4],context.push(value),partials,originalTemplate)}else if(isFunction(value)){if(typeof originalTemplate!=="string")throw new Error("Cannot use higher-order sections without the original template");value=value.call(context.view,originalTemplate.slice(token[3],token[5]),subRender);if(value!=null)buffer+=value}else{buffer+=this.renderTokens(token[4],context,partials,originalTemplate)}return buffer};Writer.prototype.renderInverted=function renderInverted(token,context,partials,originalTemplate){var value=context.lookup(token[1]);if(!value||isArray(value)&&value.length===0)return this.renderTokens(token[4],context,partials,originalTemplate)};Writer.prototype.renderPartial=function renderPartial(token,context,partials){if(!partials)return;var value=isFunction(partials)?partials(token[1]):partials[token[1]];if(value!=null)return this.renderTokens(this.parse(value),context,partials,value)};Writer.prototype.unescapedValue=function unescapedValue(token,context){var value=context.lookup(token[1]);if(value!=null)return value};Writer.prototype.escapedValue=function escapedValue(token,context){var value=context.lookup(token[1]);if(value!=null)return mustache.escape(value)};Writer.prototype.rawValue=function rawValue(token){return token[1]};mustache.name="mustache.js";mustache.version="3.0.0";mustache.tags=["{{","}}"];var defaultWriter=new Writer;mustache.clearCache=function clearCache(){return defaultWriter.clearCache()};mustache.parse=function parse(template,tags){return defaultWriter.parse(template,tags)};mustache.render=function render(template,view,partials,tags){if(typeof template!=="string"){throw new TypeError('Invalid template! Template should be a "string" '+'but "'+typeStr(template)+'" was given as the first '+"argument for mustache#render(template, view, partials)")}return defaultWriter.render(template,view,partials,tags)};mustache.to_html=function to_html(template,view,partials,send){var result=mustache.render(template,view,partials);if(isFunction(send)){send(result)}else{return result}};mustache.escape=escapeHtml;mustache.Scanner=Scanner;mustache.Context=Context;mustache.Writer=Writer;return mustache});
/* eslint-enable */
